import { Injectable } from '@angular/core';
import {Router, CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {RoleService} from "@app/services/role.service";



@Injectable()
export class RoleGuard implements CanActivate, CanActivateChild {

  constructor(public roleService: RoleService, public router: Router) {}

  async canActivate(){
    if(!this.roleService.isAuthorized()){
      await this.router.navigate(['home']);
      return false;
    }
    return true;
  }

  async canActivateChild() {
    return await this.canActivate();
  }
}
